import './Login.css'

import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
//import { UserContext } from "../store/userContext";
import http from "../Services/httpService";
import noronServices from "../Services/noronServices";
import { toast } from "react-toastify";

export default function Login() {
    let navigate = useNavigate();
    //const { reCreate } = useContext(UserContext);
    const [isPosting, setIsPosting] = useState(false);
    const [form, setForm] = useState(
        {
            Username: "", Password: ""
        });



    //const [notif, setNotif] = useState("");


    const handlePosting = async (e) => {
        /* if ('Notification' in window)
             try {
                 if (Notification.permission != 'granted') {
                     Notification.requestPermission().then((permission) => {
                         setNotif("notif:permission")
                         console.log('permission', permission);
                         if (permission === 'granted') {
                             console.log('Notification permission granted.');
                             //resetUI();
                         } else {
                             console.log('Unable to get permission to notify.');
                             setNotif("notif:error1")
                         }
                     });
                 } else
                     setNotif(Notification.permission)
             } catch (e) { setNotif("notif:error2"); console.log('permission error', e); console.log('errorRequest permision', e); }
         else
             setNotif("no Support2")*/
        e.preventDefault();

        setIsPosting(true);
        await noronServices.login(form)
            .then(({ data }) => {
                setIsPosting(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                if (data.payload.addNewUser) {
                    //console.log('1--------------');
                    navigate('/Information/', { state: { form } });
                    return;
                }
                //console.log('2--------------');
                http.setLocalJwt(data.payload.token.access_token);
                http.setLocalJwtRefresh(data.payload.token.refresh_token);
                //reCreate();
                navigate({ pathname: data.payload.addNewUser ? '/Information' : '/main' });
            })
            .catch(err => {
                setIsPosting(false);
            });
    }

    return (
        <>
            <div className="container col-xl-10 col-xxl-8 px-4 py-5">


                <div className="row align-items-center g-lg-5 py-5">
                    <div className="col-lg-7 text-center text-lg-start">
                        <h1 className="display-4 fw-bold lh-1 mb-3">سامانه آنلاین نورون</h1>
                        <p className="col-lg-10 fs-4 text-justify-center">
                            اگر برای بار اول وارد سامانه نورون میشوید جهت ورود شماره 15
                            رقمی در کارت گارانتی را وارد کنید
                            <br />
                            کلمه عبور پیش فرض 12345 می باشد
                            <br />
                            <span id="voiceHelp" className="redColor">آموزش صوتی</span>
                            <audio controls>
                                <source src="help.mpeg" type="audio/mpeg" />
                                Your browser does not support the audio element.
                            </audio>
                            <br />
                        </p>
                    </div>
                    <div className="col-md-10 mx-auto col-lg-5">
                        <form asp-action="Login" className="p-4 p-md-5 border rounded-3 bg-light" method="post">
                            <div className="form-floating mb-3">
                                <input asp-for="Username"
                                    type="number"
                                    name="Username"
                                    value={form.Username}
                                    onChange={e => http.handleChange(e, form, setForm)}
                                    className="form-control"
                                    placeholder="شماره همراه مالک" autoComplete="off" />
                                <label asp-for="Username">شماره همراه مالک</label>
                                <span asp-validation-for="Username" className="text-danger"></span>
                            </div>
                            <div className="form-floating mb-3">
                                <input asp-for="Password"
                                    id="inputPassword"
                                    type="number"
                                    name="Password"
                                    value={form.Password}
                                    onChange={e => http.handleChange(e, form, setForm)}
                                    className="form-control" placeholder="Password" autoComplete="off" />
                                <label asp-for="Password">کلمه عبور</label>
                                <span asp-validation-for="Password" className="text-danger"></span>
                            </div>

                            <button className="w-100 btn btn-lg btn-primary"

                                onClick={handlePosting}
                                disabled={isPosting}>
                                ورود
                                {isPosting &&
                                    <div className="spinner-border spinner-border-sm" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>}
                            </button>
                            <hr className="my-4" />
                            <Link to="/PasswordRecovery" className="text-decoration-none redColor">کلمه عبور را فراموش کرده اید؟</Link>
                        </form>
                    </div>
                </div>
            </div>
        </>

    );

}
